import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {BackendService} from '../../services/backend.service';
import {FoerdermittelcheckAnfrage} from '../anfrage/foerdermittelcheck.anfrage';
import {DebugService} from '../../debug/debug.service';

/**
 * Service for dealing with the backend and make request to the backend.
 */
@Injectable({
  providedIn: 'root'
})
export class FoerdermittelcheckBackendService extends BackendService {

  /**
   * @inheritDoc
   */
  requestIdName = 'foc-requestid';

  /**
   * @inheritdoc
   */
  backendDataEndpoint = '/foc/data/';

  /**
   * constructor.
   * @param http
   * @param backendService
   * @param debugService
   */
  constructor(protected http: HttpClient, private backendService: BackendService, protected debugService: DebugService) {
    super(http, debugService);
  }

  /**
   * @inheritDoc
   * this is a small workaround so other components can still access the generic backendservice and will get the real advisor name
   * @param advisor
   */
  setAdvisor(advisor: string) {
    super.setAdvisor(advisor);

    this.backendService.setAdvisor(advisor);
  }

  /**
   * starts to calculate which funding measures are relevant
   * @param anfrage
   * @param requestId
   */
  measures(anfrage: FoerdermittelcheckAnfrage, requestId: string): Observable<any> {
    return this.http.post('/foc/measures/' + requestId, anfrage).pipe(
      tap(data => {
        if (data.debug) {
          this.addDebug(data.debug);
        }
      })
    );
  }

  /**
   * starts to 'calculate' which funding programs are relevant
   * @param anfrage
   * @param requestId
   */
  programs(anfrage: FoerdermittelcheckAnfrage, requestId: string): Observable<any> {
    return this.http.post('/foc/programs/' + requestId, anfrage).pipe(
      tap(data => {
        if (data.debug) {
          this.addDebug(data.debug);
        }
      })
    );
  }

}
